
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M12 10.854h7.552c.073.406.125.802.125 1.334C19.677 16.75 16.615 20 12 20c-4.427 0-8-3.573-8-8s3.573-8 8-8c2.156 0 3.969.792 5.365 2.094l-2.177 2.093c-.594-.572-1.636-1.24-3.188-1.24-2.73 0-4.958 2.261-4.958 5.053S9.27 17.052 12 17.052c3.167 0 4.354-2.27 4.542-3.448H12v-2.75z","fill":"#fff"}})])
          )
        }
      }
    